import { Suspect } from "../types";

interface Props {
  suspects: Suspect[];
  selectedSuspect: string | null;
  bars: boolean;
  totalDetectives: number;
}

export default function StatsBlock({ suspects, selectedSuspect, bars, totalDetectives }: Props) {
  return (
    <div className="stats-block">
      <div className="stats-label">
        — How {totalDetectives.toLocaleString()} detectives voted
      </div>
      {suspects.map((s) => (
        <div className="stat-row" key={s.id}>
          <span
            className="stat-name"
            style={{ color: s.id === selectedSuspect ? "var(--gold)" : undefined }}
          >
            {s.name}
          </span>
          <div className="stat-bar-wrap">
            <div
              className={[
                "stat-bar",
                s.guilty ? "guilty-bar" : "",
                s.id === selectedSuspect && !s.guilty ? "your-pick" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              style={{ width: bars ? `${s.pct}%` : "0%" }}
            />
          </div>
          <span className="stat-pct">{s.pct}%</span>
        </div>
      ))}
    </div>
  );
}
